import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useDeletePetPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ petId, photoUrl }: { petId: string; photoUrl: string }) => {
      await api.delete(`/pets/${petId}/photo`, { data: { photoUrl } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pets'] });
    },
  });
};
